import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { HlmAvatarComponent, HlmAvatarFallbackDirective, HlmAvatarImageDirective } from '@spartan-ng/helm/avatar';
import { TelegramService } from '@infrastructure/telegram';
import { NgStyle } from '@angular/common';
import { AuthFacade } from '@feature/auth/facade';
import { BalanceFacade } from '@feature/balance/facade';
import { LanguageStore } from '@feature/language/data';
import { RouterLink } from '@angular/router';
import { resolveTelegramDisplayName } from '@utils/helpers';

@Component({
  selector: 'app-header',
  imports: [HlmAvatarComponent, HlmAvatarImageDirective, HlmAvatarFallbackDirective, NgStyle, RouterLink],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  readonly #telegram = inject(TelegramService);
  readonly #authFacade = inject(AuthFacade);
  readonly #balanceFacade = inject(BalanceFacade);
  protected readonly vm = this.#authFacade.vm;
  protected readonly balanceVm = this.#balanceFacade.vm;
  protected readonly userDisplayName = computed(() => resolveTelegramDisplayName(this.vm().user?.username, this.vm().user?.first_name));

  readonly #store = inject(LanguageStore);
  protected readonly language = this.#store.language;

  public paddingTop = 20 + 'px';
  public backdropHeight = 72 + 'px';

  public ngOnInit() {
    this.paddingTop = this.#telegram.safeYGap + 20 + 'px';
    this.backdropHeight = this.#telegram.safeYGap + 72 + 'px';
    this.#balanceFacade.loadBalance();
  }
}
